import React, { useEffect, useRef, useState } from "react";
import {
	DropdownContainerFireBase,
	DropdownContainerSelectApp,
	DropdownHeaderFireBase,
	DropdownHeaderFireBaseDiv,
	DropdownHeaderSelectApp,
	DropdownHeaderSelectAppDiv,
	DropdownHeaderSelectAppDivRes,
	DropdownListContainerFireBase,
	DropdownListContainerSelectApp,
	DropdownListFireBase,
	ErrorNotiLogin,
	FlagImageFireBase,
	FlagImageFireBaseSpan,
	FomrmLoginButton,
	FomrmLoginCreateOne,
	FomrmLoginCreateOneText,
	FomrmLoginCreateOneWrap,
	FomrmLoginInput,
	FomrmLoginInput2,
	FomrmLoginInputPhone,
	FomrmLoginInputPhoneNumberInner,
	FomrmLoginInputPhoneNumberWrap,
	FomrmLoginInputPhoneNumberWrapv2,
	FomrmLoginWrap,
	ForgotYourPassword,
	Label,
	ListItemFireBase,
	NoteErrorNotiLogin,
	Select,
	SelectWrapper,
	SeledctApp,
} from "../styled/LoginStyles";
import useLogin from "../hook/useLogin";
import { PHONE_COUNTRY_CODE } from "../hook/phoneCountryCode";
import { ActiveType, ActiveTypeMap } from "../../../../models/Login";
import useRegister from "../hook/useRegister";
import {
	CountryTopMobile,
	CountryTopMobilev2,
	CountryTopWeb,
	InnerTopMobileLabel,
	OrderInnerTopMobile,
	OrderInnerTopWeb,
} from "../../Order/styled/OrderStyle";
import {
	PersonUpdateInfoOrtheFormLogin,
	PersonUpdateInfoOrtheFormLoginWrap,
} from "../../PersonalInformation/styled/PersonInfoStyled";
import { STYLE_CODE, STYLE_CODE_RES } from "../../../controls/components/Contact/ContactCode";

export default function FomrCreateOne(props: {
	setOpenDialog: (value: boolean) => void;
	setOpenDialogLogin: (value: boolean) => void;
}) {
	const [loading, setLoading] = useState(false);
	const { doRegister, errorMess } = useRegister({ setOpenDialog: props.setOpenDialog, setLoading: setLoading });
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [cfpassword, setCfPassword] = useState("");
	const [localErrorMess, setLocalErrorMess] = useState("");
	const [phone, setPhone] = useState("");
	const [selectedCountryCode, setSelectedCountryCode] = useState(PHONE_COUNTRY_CODE[0].dial_code);
	const [type, setType] = useState("0");

	const handleLogin = async () => {
		if (!email || !password || !cfpassword || !name || !type) {
			setLocalErrorMess("Please complete all information.");
			return;
		}
		if (password != cfpassword) {
			setLocalErrorMess("Password does not match. Please try again");
			return;
		}
		const phoneRegex = /^[0-9]+$/;
		// if (!phoneRegex.test(phone)) {
		// 	setLocalErrorMess("The phone numbers can only be entered as numbers");
		// 	return;
		// }
		const formattedPhone = selectedCountryCode == "+84" && phone.startsWith("0") ? phone.substring(1) : phone;
		const formattedPhoneNo = phone ? selectedCountryCode + formattedPhone : "";
		setLocalErrorMess("");
		setLoading(true);
		await doRegister(name, email, password, cfpassword, type, formattedPhoneNo);
	};

	const handleCreateOne = async () => {
		props.setOpenDialog(false);
		props.setOpenDialogLogin(true);
	};

	return (
		<FomrmLoginWrap>
			<PersonUpdateInfoOrtheFormLoginWrap>
				<InnerTopMobileLabel>Full name (Required)</InnerTopMobileLabel>
				<PersonUpdateInfoOrtheFormLogin
					value={name}
					onChange={(e) => setName(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							handleLogin();
						}
					}}
				/>
			</PersonUpdateInfoOrtheFormLoginWrap>
			<PersonUpdateInfoOrtheFormLoginWrap>
				<InnerTopMobileLabel>Email (Required)</InnerTopMobileLabel>
				<PersonUpdateInfoOrtheFormLogin
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							handleLogin();
						}
					}}
				/>
			</PersonUpdateInfoOrtheFormLoginWrap>
			<PersonUpdateInfoOrtheFormLoginWrap>
				<InnerTopMobileLabel>Password (Required)</InnerTopMobileLabel>
				<PersonUpdateInfoOrtheFormLogin
					value={password}
					type="password"
					onChange={(e) => setPassword(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							handleLogin();
						}
					}}
				/>
			</PersonUpdateInfoOrtheFormLoginWrap>
			<PersonUpdateInfoOrtheFormLoginWrap>
				<InnerTopMobileLabel>Confirm Password (Required)</InnerTopMobileLabel>
				<PersonUpdateInfoOrtheFormLogin
					type="password"
					value={cfpassword}
					onChange={(e) => setCfPassword(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							handleLogin();
						}
					}}
				/>
			</PersonUpdateInfoOrtheFormLoginWrap>
			{localErrorMess || errorMess ? (
				<ErrorNotiLogin>{localErrorMess || errorMess}</ErrorNotiLogin>
			) : (
				<NoteErrorNotiLogin></NoteErrorNotiLogin>
			)}
			<CountryTopMobilev2>
				<CustomDropdown
					selectedCountryCode={selectedCountryCode}
					setSelectedCountryCode={setSelectedCountryCode}
				/>
			</CountryTopMobilev2>
			<FomrmLoginInputPhoneNumberWrapv2>
				<FomrmLoginInputPhoneNumberInner>
					<CountryTopWeb>
						<CustomDropdown
							selectedCountryCode={selectedCountryCode}
							setSelectedCountryCode={setSelectedCountryCode}
						/>
					</CountryTopWeb>
					<FomrmLoginInputPhone
						placeholder="Phone number"
						value={phone}
						onChange={(e) => setPhone(e.target.value)}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								handleLogin();
							}
						}}
					/>
				</FomrmLoginInputPhoneNumberInner>
				<SeledctApp>
					<SelectApp
						type={type}
						setType={setType}
					/>
				</SeledctApp>
			</FomrmLoginInputPhoneNumberWrapv2>
			<FomrmLoginButton
				onClick={handleLogin}
				disabled={loading}
				$loading={loading}>
				{loading ? "Logging in..." : "Sign up now"}
			</FomrmLoginButton>
			<FomrmLoginCreateOneWrap>
				<FomrmLoginCreateOneText>Don’t have an account?</FomrmLoginCreateOneText>
				<FomrmLoginCreateOne onClick={handleCreateOne}>Log in</FomrmLoginCreateOne>
			</FomrmLoginCreateOneWrap>
		</FomrmLoginWrap>
	);
}

export function CustomDropdown(props: {
	selectedCountryCode: string;
	setSelectedCountryCode: (value: string) => void;
	isUserExist?: boolean;
}) {
	const [isOpen, setIsOpen] = useState(false);
	const selectedCountry = PHONE_COUNTRY_CODE.find((country) => country.dial_code === props.selectedCountryCode);

	const toggleDropdown = () => setIsOpen(!isOpen);
	const handleOptionClick = (dial_code: any) => {
		props.setSelectedCountryCode(dial_code);
		setIsOpen(false);
	};
	const dropdownRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const handleClickOutside = (event: any) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [dropdownRef]);

	return (
		<DropdownContainerFireBase disable={props.isUserExist}>
			<DropdownHeaderFireBase onClick={toggleDropdown}>
				<DropdownHeaderFireBaseDiv>
					<FlagImageFireBase
						src={selectedCountry?.image}
						alt={selectedCountry?.name}
					/>
					<FlagImageFireBaseSpan> {selectedCountry?.name}</FlagImageFireBaseSpan> {selectedCountry?.dial_code}
				</DropdownHeaderFireBaseDiv>
				<i
					className="fa fa-angle-down"
					aria-hidden="true"></i>
			</DropdownHeaderFireBase>
			{isOpen && (
				<DropdownListContainerFireBase ref={dropdownRef}>
					<DropdownListFireBase>
						{PHONE_COUNTRY_CODE.map((country) => (
							<ListItemFireBase
								key={country.code}
								onClick={() => handleOptionClick(country.dial_code)}>
								<FlagImageFireBase
									src={country.image}
									alt={country.name}
								/>
								{country.dial_code} {country.name}
							</ListItemFireBase>
						))}
					</DropdownListFireBase>
				</DropdownListContainerFireBase>
			)}
		</DropdownContainerFireBase>
	);
}

export function SelectApp(props: { type: string; setType: (value: string) => void }) {
	const [isOpen, setIsOpen] = useState(false);
	const selectedCountry = STYLE_CODE.find((country) => country.code == props.type);
	const selectedCountryRes = STYLE_CODE_RES.find((country) => country.code == props.type);

	const toggleDropdown = () => setIsOpen(!isOpen);
	const handleOptionClick = (dial_code: any) => {
		props.setType(dial_code);
		setIsOpen(false);
	};
	const dropdownRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const handleClickOutside = (event: any) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [dropdownRef]);

	return (
		<DropdownContainerSelectApp
			onClick={toggleDropdown}
			ref={dropdownRef}>
			<DropdownHeaderSelectApp>
				<DropdownHeaderSelectAppDiv>
					{/* <FlagImageFireBase src={selectedCountry?.image} alt={selectedCountry?.name} /> */}
					{selectedCountry?.name}
				</DropdownHeaderSelectAppDiv>
				<DropdownHeaderSelectAppDivRes>
					{/* <FlagImageFireBase src={selectedCountry?.image} alt={selectedCountry?.name} /> */}
					{selectedCountryRes?.name}
				</DropdownHeaderSelectAppDivRes>
				<i
					className="fa fa-angle-down"
					aria-hidden="true"></i>
			</DropdownHeaderSelectApp>
			{isOpen && (
				<DropdownListContainerSelectApp>
					<DropdownListFireBase>
						{STYLE_CODE.map((country) => (
							<ListItemFireBase
								key={country.code}
								onClick={() => handleOptionClick(country.code)}>
								<FlagImageFireBase
									src={country.image||""}
									alt={country.name}
								/>
								{country.name}
							</ListItemFireBase>
						))}
					</DropdownListFireBase>
				</DropdownListContainerSelectApp>
			)}
		</DropdownContainerSelectApp>
	);
}
